import { Field, Form } from "react-final-form";
import { Alert, Box, Button, CircularProgress, TextField } from "@mui/material";
import React, { useState } from "react";
import { useAuth } from "../../../utils/context/auth-context";
import { ISignInRequest } from "../../../models/SignInRequest";
import { ActionButton } from "../../../components/ui/buttons/action-button";
import { useNavigate } from "react-router-dom";
import { PasswordField } from "../../../components/fields/password/password-field";

export const SignInForm = () => {
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const auth = useAuth();
  const navigate = useNavigate();

  const login = (loginData: ISignInRequest) => {
    setLoading(true);
    auth.login({ data: loginData, setError, setLoading });
  };

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <Form
        onSubmit={login}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box display={"flex"} flexDirection={"column"} gap={2}>
              <Field name="username">
                {({ input }) => (
                  <TextField
                    color="secondary"
                    autoComplete="on"
                    size="small"
                    fullWidth
                    label="Email"
                    required
                    {...input}
                  />
                )}
              </Field>
              <PasswordField fieldName={"password"} fieldLabel={"Password"} />
              {!!error && (
                <Alert severity={"error"}>
                  {" "}
                  Error: Wrong Username/Password{" "}
                </Alert>
              )}
              <Button
                fullWidth
                variant="contained"
                color="secondary"
                type="submit"
              >
                {" "}
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Sign in"
                )}{" "}
              </Button>
            </Box>
          </form>
        )}
      ></Form>
      <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
        <ActionButton
          title={"Forgot Password?"}
          onClick={() => navigate("/reset")}
        />
        <ActionButton
          title={"Don't have an account? Sign up here!"}
          onClick={() => navigate("/sign-up")}
        />
      </Box>
    </Box>
  );
};
